export enum indentstatusenum{
    OPEN='OPEN',
    IN_PROGRESS='IN PROGRESS',
    CLOSE='CLOSE',
    CANCEL='CANCEL',
    PARTIALLY_TRANSFERRED='PARTIALLY TRANSFERRED'
}